import { Body, dsColors, dsSizing } from '@Backlot-Cars/archie';
import DOMPurify from 'isomorphic-dompurify';
import { useMemo } from 'react';
import styled from 'styled-components';

const SanitizedHtmlContainer = styled(Body)`
	a {
		font-size: ${dsSizing.fontContent.fontContentDefault};
		color: ${dsColors.colorTextLink.primary};
		text-decoration: underline;
	}

	b {
		font-weight: var(--fontWeightSemiBold);
	}

	a:active,
	a:visited {
		color: ${dsColors.colorTextLink.visited};
		text-decoration: none;
	}
`;

const SanitizedHtmlContainerPrimary = styled(SanitizedHtmlContainer)`
	a {
		color: ${dsColors.colorBrand.primary};
		text-decoration: none;
		font-weight: var(--fontWeightSemiBold);
	}
`;

const SAFE_HTML_TAGS = new Set(['article', 'div', 'section', 'span']);

export const SanitizedHtmlBody = ({ html, variant, as: tag, ...props }) => {
	// Only allow inert tags; a script or style wrapper would make sanitized text executable.
	const BodyComponent = variant === 'primary' ? SanitizedHtmlContainerPrimary : SanitizedHtmlContainer;
	const Component = SAFE_HTML_TAGS.has(tag) ? tag : BodyComponent;
	const sanitizedHtml = useMemo(() => DOMPurify.sanitize(html), [html]);
	return <Component {...props} dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />;
};
